import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=60e4ee82&scoped=true&"
import script from "./PlayerCard.vue?vue&type=script&lang=js&"
export * from "./PlayerCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCard.vue?vue&type=style&index=0&id=60e4ee82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4ee82",
  null
  
)

export default component.exports